import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getFieldPropertiesByTarget, isFormEmpty } from '@wix/form-viewer/controller';
import { createOrderAndCharge, getCheckout, updateCheckout } from '@wix/ambassador-ecom-v1-checkout/http';
import { ambassadorWithHeaders } from '../../utils/ambassador.utils';
import { getIsCheckoutComposerEnabled } from '../apis/getIsCheckoutExperimentEnabled';
import { FORMS_TEMPLATE_IDS, FQDN } from '../../utils/consts';
export class CheckoutService {
  constructor(httpClient, controllerConfig, getCurrency) {
    _defineProperty(this, "requestWithHeaders", void 0);
    _defineProperty(this, "httpClient", void 0);
    this.httpClient = httpClient;
    this.requestWithHeaders = () => ambassadorWithHeaders(httpClient, controllerConfig, getCurrency());
  }
  async getCheckoutByCheckoutId(checkoutId) {
    const {
      data
    } = await this.requestWithHeaders()(getCheckout({
      id: checkoutId
    }));
    return data.checkout;
  }
  async isExtendedFieldsFormEmpty() {
    const isEmpty = await isFormEmpty({
      formId: FORMS_TEMPLATE_IDS.EXTENDED_FIELDS_FORM_ID,
      httpClient: this.httpClient
    });
    return isEmpty != null ? isEmpty : true;
  }
  async doesFormHaveRequiredDataExtendedFields() {
    const fieldProps = await getFieldPropertiesByTarget({
      options: {
        fqdn: FQDN
      },
      httpClient: this.httpClient,
      formId: FORMS_TEMPLATE_IDS.CUSTOMER_DETAILS_WO_ADDITIONAL_INFO
    });
    const fieldValues = fieldProps ? Object.values(fieldProps) : [];
    return fieldValues.filter(fieldValue => fieldValue == null ? void 0 : fieldValue.required).length > 0;
  }
  isCheckoutComposerEnabled() {
    return getIsCheckoutComposerEnabled(this.httpClient);
  }
  async createOrderAndCharge(_ref) {
    let {
      id,
      paymentToken,
      urlParams
    } = _ref;
    let orderId;
    let paymentResponseToken;
    try {
      const request = {
        id,
        paymentToken,
        urlParams
      };
      const {
        data
      } = await this.requestWithHeaders()(createOrderAndCharge(request));
      orderId = data.orderId;
      paymentResponseToken = data.paymentResponseToken;
    } catch (_unused) {
      orderId = undefined;
      paymentResponseToken = undefined;
    }
    return {
      orderId,
      paymentResponseToken
    };
  }
  async updateCheckoutForShippingEstimation(checkoutId, address) {
    const {
      data
    } = await this.requestWithHeaders()(updateCheckout({
      checkout: {
        id: checkoutId,
        shippingInfo: {
          shippingDestination: {
            address
          }
        }
      },
      fieldMask: ['shippingInfo.shippingDestination.address.country', 'shippingInfo.shippingDestination.address.postalCode', 'shippingInfo.shippingDestination.address.subdivision']
    }));
    return data.checkout;
  }
  async updateCheckoutByShippingAndBillingContacts(checkoutId, shouldUpdateShippingAddress, shippingContact, billingContact) {
    var _shippingContact$name, _shippingContact$name2;
    const {
      data
    } = await this.requestWithHeaders()(updateCheckout({
      checkout: {
        id: checkoutId,
        ...(shouldUpdateShippingAddress && {
          shippingInfo: {
            shippingDestination: {
              address: {
                country: shippingContact == null ? void 0 : shippingContact.country,
                subdivision: shippingContact == null ? void 0 : shippingContact.subdivision,
                postalCode: shippingContact == null ? void 0 : shippingContact.zipCode,
                city: shippingContact == null ? void 0 : shippingContact.city,
                addressLine: shippingContact == null ? void 0 : shippingContact.addressLine1,
                addressLine2: shippingContact == null ? void 0 : shippingContact.addressLine2
              },
              contactDetails: {
                firstName: shippingContact == null || (_shippingContact$name = shippingContact.name) == null ? void 0 : _shippingContact$name.firstName,
                lastName: shippingContact == null || (_shippingContact$name2 = shippingContact.name) == null ? void 0 : _shippingContact$name2.lastName,
                phone: (shippingContact == null ? void 0 : shippingContact.phoneNumber) || undefined
              }
            }
          }
        }),
        buyerInfo: {
          email: billingContact == null ? void 0 : billingContact.email
        },
        billingInfo: {
          address: {
            country: billingContact == null ? void 0 : billingContact.countryCode,
            postalCode: billingContact == null ? void 0 : billingContact.postalCode,
            city: billingContact == null ? void 0 : billingContact.city,
            subdivision: billingContact == null ? void 0 : billingContact.state
          },
          contactDetails: {
            firstName: billingContact == null ? void 0 : billingContact.firstName,
            lastName: billingContact == null ? void 0 : billingContact.lastName,
            phone: billingContact == null ? void 0 : billingContact.phone
          }
        }
      },
      fieldMask: ['billingInfo', 'buyerInfo.email', ...(shouldUpdateShippingAddress ? ['shippingInfo.shippingDestination'] : [])]
    }));
    return data.checkout;
  }
  async updateCheckoutByShippingContacts(checkoutId, shouldUpdateShippingAddress, billingContact, shippingContact, shouldForwardContactDetailsPickupFlow) {
    var _shippingContact$name3, _shippingContact$name4, _shippingContact$name5, _shippingContact$name6;
    console.log('shouldUpdateShippingAddress', shouldUpdateShippingAddress);
    const {
      data
    } = await this.requestWithHeaders()(updateCheckout({
      checkout: {
        id: checkoutId,
        buyerInfo: {
          email: billingContact == null ? void 0 : billingContact.email
        },
        ...(shouldUpdateShippingAddress && {
          shippingInfo: {
            shippingDestination: {
              address: {
                country: shippingContact == null ? void 0 : shippingContact.country,
                subdivision: shippingContact == null ? void 0 : shippingContact.subdivision,
                postalCode: shippingContact == null ? void 0 : shippingContact.zipCode,
                city: shippingContact == null ? void 0 : shippingContact.city,
                addressLine: shippingContact == null ? void 0 : shippingContact.addressLine1,
                addressLine2: shippingContact == null ? void 0 : shippingContact.addressLine2
              },
              contactDetails: {
                firstName: shippingContact == null || (_shippingContact$name3 = shippingContact.name) == null ? void 0 : _shippingContact$name3.firstName,
                lastName: shippingContact == null || (_shippingContact$name4 = shippingContact.name) == null ? void 0 : _shippingContact$name4.lastName,
                phone: (shippingContact == null ? void 0 : shippingContact.phoneNumber) || undefined
              }
            }
          }
        }),
        ...(shouldForwardContactDetailsPickupFlow && !shouldUpdateShippingAddress && {
          shippingInfo: {
            shippingDestination: {
              contactDetails: {
                firstName: shippingContact == null || (_shippingContact$name5 = shippingContact.name) == null ? void 0 : _shippingContact$name5.firstName,
                lastName: shippingContact == null || (_shippingContact$name6 = shippingContact.name) == null ? void 0 : _shippingContact$name6.lastName,
                phone: (shippingContact == null ? void 0 : shippingContact.phoneNumber) || undefined
              }
            }
          }
        })
      },
      fieldMask: ['buyerInfo.email', ...(shouldUpdateShippingAddress ? ['shippingInfo.shippingDestination'] : []), ...(shouldForwardContactDetailsPickupFlow && !shouldUpdateShippingAddress ? ['shippingInfo.shippingDestination.contactDetails'] : [])]
    }));
    return data.checkout;
  }
  async updateCheckoutByBillingContacts(checkoutId, billingContact) {
    const {
      data
    } = await this.requestWithHeaders()(updateCheckout({
      checkout: {
        id: checkoutId,
        billingInfo: {
          address: {
            country: billingContact == null ? void 0 : billingContact.countryCode,
            postalCode: billingContact == null ? void 0 : billingContact.postalCode,
            city: billingContact == null ? void 0 : billingContact.city,
            subdivision: billingContact == null ? void 0 : billingContact.state
          },
          contactDetails: {
            firstName: billingContact == null ? void 0 : billingContact.firstName,
            lastName: billingContact == null ? void 0 : billingContact.lastName,
            phone: billingContact == null ? void 0 : billingContact.phone
          }
        }
      },
      fieldMask: ['billingInfo']
    }));
    return data.checkout;
  }
  async setShippingOption(checkoutId, shippingOptionId) {
    const {
      data
    } = await this.requestWithHeaders()(updateCheckout({
      checkout: {
        id: checkoutId,
        shippingInfo: {
          selectedCarrierServiceOption: {
            code: shippingOptionId
          }
        }
      },
      fieldMask: ['shippingInfo.selectedCarrierServiceOption']
    }));
    return data.checkout;
  }
}
//# sourceMappingURL=CheckoutService.js.map